<template>
  <Teleport to="body">
    <div class="sub-modal-backdrop" @click="$emit('back')">
      <div class="sub-modal card" @click.stop>
        <div class="card-body">
          <p class="sub-modal__body mb-4">
            Sorry to hear you're having trouble, do you want to contact support before you cancel?
          </p>
          <div class="d-flex gap-2 mb-3">
            <button type="button" class="btn btn-outline-secondary flex-fill" @click="$emit('back')">Back</button>
            <button type="button" class="btn btn-primary flex-fill" @click="$emit('contact')">
              Contact support
            </button>
          </div>
          <button type="button" class="btn btn-link w-100 text-decoration-underline" @click="$emit('continue')">
            Continue cancellation
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
defineEmits<{ (e: "back"): void; (e: "contact"): void; (e: "continue"): void }>();
</script>

<style scoped lang="scss">
.sub-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1.5rem;
}

.sub-modal {
  max-width: 420px;
  width: 100%;
  border-radius: 16px;

  &__body {
    font-size: 1.05rem;
    font-weight: 600;
  }
}
</style>
